import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import DoNotDisturbOnOutlinedIcon from '@mui/icons-material/DoNotDisturbOnOutlined';

interface RatingFieldProps {
  value: boolean | null;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

function RatingField({
  value,
  onChange,
  disabled = false,
}: RatingFieldProps): React.JSX.Element {
  return (
    <Stack direction='row' spacing={1} alignItems='center'>
      <Tooltip title='Approve'>
        <Box component='span'>
          <IconButton
            color={value === true ? 'success' : 'inherit'}
            onClick={() => onChange(true)}
            disabled={disabled}
            aria-label='Approve'
            sx={{ color: value === true ? undefined : 'text.secondary' }}
          >
            {value === true ? <CheckCircleIcon /> : <CheckCircleOutlineIcon />}
          </IconButton>
        </Box>
      </Tooltip>
      <Tooltip title='Reject'>
        <Box component='span'>
          <IconButton
            color={value === false ? 'error' : 'inherit'}
            onClick={() => onChange(false)}
            disabled={disabled}
            aria-label='Reject'
            sx={{ color: value === false ? undefined : 'text.secondary' }}
          >
            {value === false ? (
              <DoNotDisturbOnIcon />
            ) : (
              <DoNotDisturbOnOutlinedIcon />
            )}
          </IconButton>
        </Box>
      </Tooltip>
    </Stack>
  );
}

export default RatingField;
